import { render } from "./detail-shipping.component.vue?vue&type=template&id=2cd852b1&ts=true"
import script from "./detail-shipping.component.vue?vue&type=script&lang=ts"
export * from "./detail-shipping.component.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__